// extracted by mini-css-extract-plugin
module.exports = {"sectionComboTitle":"ListContentsBlock_sectionComboTitle__LIdqm"};